export const validateIdentifierRepeat = (identifier, _data) => {
  return !!_.find(_data, { identifier: identifier, state: "created" })
}

export const validateEmailRepeat = (email, _data) => {
  return !!_.find(_data, { value: email, state: "created" })
}
